import { stringFormatter } from '@nhl/formatter-utilities';

import statsReportAPI from 'media-base-ui/utils/statsReportAPI';

import actionCreators from './actionCreators';

const fetchCountryData = () => async dispatch => {
    dispatch(actionCreators.requestCountry());

    try {
        const data = await statsReportAPI.fetchPlayerCountries();
        dispatch(actionCreators.countryResponse(true, data.data, null))
    } catch (error) {
        dispatch(actionCreators.countryResponse(false, [], error));
    }
};

const fetchReportData = (reportCategory, reportType, filterFlags, reportArgs) => async dispatch => {
    const fetchFunction = statsReportAPI['fetch'  + stringFormatter.capitalize(stringFormatter.slugToCamelCase(reportCategory)) + stringFormatter.capitalize(stringFormatter.slugToCamelCase(reportType)) + 'Report'];

    dispatch(actionCreators.requestReportData());

    try {
        const data = await fetchFunction({
            filterFlags,
            ...reportArgs
        });

        dispatch(actionCreators.reportDataResponse(true, {[reportCategory]: {[reportType]: { data: data.data, total: data.total }}}, null));
    } catch (error) {
        dispatch(actionCreators.reportDataResponse(false, {}, error));
    }
};

const fetchFranchiseData = () => async dispatch => {
    dispatch(actionCreators.requestFranchise());
    try {
        const data = await statsReportAPI.fetchFranchises();
        dispatch(actionCreators.franchiseResponse(true, data.data, null));
    } catch (error) {
        dispatch(actionCreators.franchiseResponse(false, [], error));
    }
}

export default {
    fetchCountryData,
    fetchFranchiseData,
    fetchReportData,
};